'use client';

import _ from 'lodash';
import { useMemo } from 'react';

import {
  LOCAL_STORAGE_KEYS,
  removeLocalStorageValue
} from '@/services/localStorage.service';
import { Breadcrumbs, TermsAndConditions } from 'components/atomic/molecules';
import StandardLayout from 'components/layout/StandardLayout';
import { isAuthenticated } from 'services/identity.service';
import { PAGE_NAME, getPageURL } from 'services/partnerPortal.service';

const TermsAndCondition = () => {
  const isAuthenticatedUser = isAuthenticated();

  const breadCrumbs = useMemo(
    () => [
      {
        name: isAuthenticatedUser ? 'Home' : 'Login',
        link: isAuthenticatedUser
          ? getPageURL({ pageName: PAGE_NAME.HOME.label })
          : getPageURL({ pageName: PAGE_NAME.LOGIN.label }),
        onClick: () =>
          removeLocalStorageValue({
            keys: [
              LOCAL_STORAGE_KEYS.DATE_PICKER_VALUE,
              LOCAL_STORAGE_KEYS.DATE_RANGE
            ]
          })
      },
      { name: 'Terms and Conditions' }
    ],
    [isAuthenticatedUser]
  );

  return (
    <StandardLayout
      {...{
        loading: _.isEmpty(breadCrumbs),
        pageDataFound: !_.isEmpty(breadCrumbs),
        showFooter: false,
        showHeader: true,
        showWhatsapp: false,
        showCallIcon: false
      }}
    >
      <div className='hidden md:flex mx-20 my-4'>
        <Breadcrumbs
          {...{
            breadCrumbs
          }}
        />
      </div>
      <TermsAndConditions />
    </StandardLayout>
  );
};

export default TermsAndCondition;
